import React from "react";
import loading from "../assets/loading.svg";

const Loading = () => (
  <div className="spinner">
    <img width="120" src={loading} alt="Loading" />
  </div>
);

export default Loading;
